import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/view/homePage'
import IntroductionPage from '@/view/introduction'
import Membership from '@/view/membership'
import AboutUs from '@/view/aboutUs'
import Page404 from '@/view/404'
import NavCompent from '@/components/navTop/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/HomePage'
    },
    {
      path:'/',
      name:'NavCompent',
      component:NavCompent,
      children:[{
        path: '/HomePage',
        name: 'HomePage',
        component: HomePage,
        meta:{
          title:'首页'
        }
      },{
        path:'/introductionPage',
        name:'IntroductionPage',
        component:IntroductionPage,
        meta:{
          title:'产品与服务'
        }
      },{
        path:'/membership',
        name:'Membership',
        component:Membership,
        meta:{
          title:'价格'
        }
      },{
        path:'/aboutUs',
        name:'AboutUs',
        component:AboutUs,
        meta:{
          title:'关于太目'
        }
      },]
    },
    {
      path:'/404',
      name:'Page404',
      component:Page404,
      meta:{
        isHiddenBotton:true,
      }
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js